import { campaignParameters } from '@gopuff/cdp-event-schemas'

export function analyticsUrlParamsIdentify() {
  if (typeof window !== 'undefined') {
    const mostRecentCampaign = campaignParameters(
      window?.location?.href || '',
      document?.referrer || ''
    )
    window.onload = () => {
      window.analytics?.identify({ most_recent_campaign: mostRecentCampaign })
    }
  }
}
